var map = {
	"./01.jpg": 8538,
	"./01.webp": 3840,
	"./02.jpg": 2438,
	"./02.webp": 6788,
	"./03.jpg": 7913,
	"./03.webp": 624,
	"./04.jpg": 6094,
	"./05.jpg": 4583,
	"./06.jpg": 2256,
	"./Thumbs.db": 4542,
	"./large/01.jpg": 1652,
	"./large/02.jpg": 4056,
	"./large/03.jpg": 9948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9773;